import Authenticate from "../views/Authenticate.vue";
import Folder from "../views/Folder.vue";
import Index from "../views/Index.vue";
import NoFolders from "../views/NoFolders.vue";
import Vue from "vue";
import VueRouter, { Route } from "vue-router";
import multiguard from "vue-router-multiguard";
import navigationGuards from "./navigationGuards";

Vue.use(VueRouter);

export const routes = [
  {
    name: "index",
    path: "/",
    component: Index
  },
  {
    name: "folder",
    path: "/folder/:folderId",
    props: true,
    component: Folder
  },
  {
    name: "edit",
    path: "/folder/:folderId/edit",
    props: (route: Route) => {
      return {
        ...route.params,
        action: "edit"
      };
    },
    component: Folder
  },
  {
    name: "choose-folder-template",
    path: "/folder/:folderId/choose-folder-template",
    props: (route: Route) => {
      return {
        ...route.params,
        action: "chooseFolderTemplate"
      };
    },
    component: Folder
  },
  {
    name: "confirm",
    path: "/folder/:folderId/confirm",
    props: (route: Route) => {
      return {
        ...route.params,
        action: "confirm"
      };
    },
    component: Folder
  },
  {
    name: "addFolderList",
    path: "/folder/:folderId/addFolderList",
    props: (route: Route) => {
      return {
        ...route.params,
        action: "addFolderList"
      };
    },
    component: Folder
  },
  {
    name: "editFolderList",
    path: "/folder/:folderId/editFolderList/:folderListId",
    props: (route: Route) => {
      return {
        ...route.params,
        action: "editFolderList"
      };
    },
    component: Folder
  },
  {
    name: "confirmDeleteFolderList",
    path: "/folder/:folderId/confirmDeleteFolderList/:folderListId",
    props: (route: Route) => {
      return {
        ...route.params,
        action: "confirmDeleteFolderList"
      };
    },
    component: Folder
  },
  {
    name: "folderNotFound",
    path: "/folderNotFound"
  },
  {
    name: "noFolders",
    path: "/no-folders",
    component: NoFolders
  },
  {
    name: "authenticate",
    path: "/authenticate",
    component: Authenticate
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(multiguard(navigationGuards));

export default router;
